import {
  InjectionToken,
  EnvironmentProviders,
  makeEnvironmentProviders,
} from '@angular/core';

export const API_BASE_PATH = new InjectionToken<string>('API_BASE_PATH');

export function provideApiConfig(basePath: string): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: API_BASE_PATH,
      useValue: basePath,
    },
  ]);
}
